/**
 * @param {String} filterName The name of the filter dropdown to toggle
 */

// This function hides/shows the filter category selected. (mobile and desktop)
function toggleDropdown(filterName) {
    let filterElement = document.querySelector(`.filter-name-${filterName}`);
    filterElement.classList.toggle("closed");
}

// This function hides/shows the sort by category on mobile
function toggleDropdownSort() {
    let sortElement = document.getElementById("sort-by2");
    let sortHeaderElement = document.getElementById("sort-by-2-header");
    sortElement.classList.toggle("closed");
    sortHeaderElement.classList.toggle("closed");
}

// This handles hide/show filters functionality on desktop & large tablets
document.addEventListener("DOMContentLoaded", function () {
    if (screen.width > 480) {
        // The "More/Less Filters Button"
        let hideShowFilters = document.getElementById("span-more-less-filters");
        // The sidebar
        let entireSidebar = document.getElementById("entire-sidebar");
        // The products that are displayed in the collection
        let collectionContent = document.getElementById("collection-content-thumbnails");
        // Show
        let spanShowFilter = document.getElementById("span-show-filters");
        // Hide
        let spanHideFilter = document.getElementById("span-hide-filters");
        // All divs used by thumbnails
        const divs = document.querySelectorAll('.three.columns.thumbnail');

        try {
          hideShowFilters.addEventListener("click", function () {
              entireSidebar.classList.toggle("hidden");
              collectionContent.classList.toggle("twelve");
              collectionContent.classList.toggle("sixteen");
              divs.forEach(div => {
                  div.classList.toggle('three');
                  div.classList.toggle('four');
              });
              spanShowFilter.classList.toggle('hide-me');
              spanHideFilter.classList.toggle('hide-me');
          })
        } catch (e) {
            
        }
    }
});

// This handles functionality on mobile devices
document.addEventListener("DOMContentLoaded", function () {
    if (screen.width < 481) {
        let drawer = document.getElementById("filter-drawer");

        let form = document.getElementById("filter-form");

        // On mobile, want checkboxes to not reload the page every time a filter is checked
        let checkboxes = document.querySelectorAll(".filter-checkbox");
        checkboxes.forEach(function (element) {
            element.removeAttribute("onchange");
        });

        // This gets the filter button and makes it toggle the drawer
        let hideShowFilters = document.getElementById("span-more-less-filters");
        hideShowFilters.addEventListener("click", toggleDrawer);

        // Clones all the filters from the sidebar and removes it from sidebar
        let filterContent = document.getElementById("filter-content");
        let filterContentClone = filterContent.cloneNode(true);
        filterContent.parentNode.removeChild(filterContent);

        // Places the filters before the submit filters button
        let fatButton = document.getElementById("filter-drawer-fat-button");
        drawer.insertBefore(filterContentClone, fatButton);

        // Clones all the collections from the sidebar and removes it from sidebar
        let collectionContent = document.getElementById("collection-content");
        let collectionContentClone = collectionContent.cloneNode(true);
        collectionContent.parentNode.removeChild(collectionContent);

        // Move to the right slightly so the indicator line is a bit further away on mobile
        collectionContentClone.classList.toggle("move-right-7px")

        // Places the collections before the sort by in the mobile drawer
        let sortBy = document.getElementById("sort-by-2-header");
        drawer.insertBefore(collectionContentClone, sortBy);

        // Add onclick to the X in the top right of the drawer
        let closeDrawer = document.getElementById("close-drawer");
        closeDrawer.addEventListener("click", submitForm);

        // Add onclick to the overlay for the drawer
        let overlay = document.getElementById("filter-overlay");
        overlay.addEventListener("click", submitForm);

        document.getElementById("your-id").addEventListener("click", function () {
          form.submit();
        });
    }
});

function submitForm() {
  let form = document.getElementById("filter-form");
  form.submit();
}

// Helper function to toggle drawer display/hide
function toggleDrawer() {
    let drawer = document.getElementById("filter-drawer");
    let overlay = document.getElementById("filter-overlay");
    drawer.classList.toggle("open");
    overlay.classList.toggle("open");
}


// This function is an onclick for all the filters to send data to GTM
function filtersGTMSendData(filter_clicked) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'filter_clicked_'+filter_clicked,
    'filter': filter_clicked,
  });
}